import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

export interface LinkParams {
  path: string;
  href: string;
  buttonTitle: string;
}

const CustomLink: FC<{ linkParams: LinkParams }> = ({
  linkParams: { href, path, buttonTitle }
}: {
  linkParams: LinkParams;
}) => {
  if (path) {
    return (
      <NavLink
        to={path}
        className="mb-2 mt-3 py-3.5 rounded bg-primary-300 text-white text-center"
      >
        {buttonTitle}
      </NavLink>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="mb-2 mt-3 py-3.5 rounded bg-primary-300 text-white text-center"
      >
        {buttonTitle}
      </a>
    );
  }

  return null;
};

export default CustomLink;
